namespace RioERP.Shipping {
    export interface ShippingTrackingNumbersForm {
        ShippingProviderId: Serenity.LookupEditor;
        TrackingNumber: Serenity.StringEditor;
        OrderId: Serenity.LookupEditor;
        ESource: Serenity.EnumEditor;
        IssueDate: Serenity.DateEditor;
        EStatus: Serenity.EnumEditor;
        BarcodeType: Serenity.EnumEditor;
        BarcodeImage: Serenity.ImageUploadEditor;
    }

    export class ShippingTrackingNumbersForm extends Serenity.PrefixedContext {
        static formKey = 'Shipping.ShippingTrackingNumbers';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ShippingTrackingNumbersForm.init)  {
                ShippingTrackingNumbersForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.EnumEditor;
                var w3 = s.DateEditor;
                var w4 = s.ImageUploadEditor;

                Q.initFormType(ShippingTrackingNumbersForm, [
                    'ShippingProviderId', w0,
                    'TrackingNumber', w1,
                    'OrderId', w0,
                    'ESource', w2,
                    'IssueDate', w3,
                    'EStatus', w2,
                    'BarcodeType', w2,
                    'BarcodeImage', w4
                ]);
            }
        }
    }
}
